module.exports = __webpack_public_path__ + "img/ranking_two.efd52c92.png";